// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerifiedOutlinedSvg from "@fishx/icons-svg/es/asn/VerifiedOutlined";
import FishxIcon from '../components/FishxIcon';

var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerifiedOutlinedSvg
  }));
};

VerifiedOutlined.displayName = 'VerifiedOutlined';
export default React.forwardRef(VerifiedOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerifiedOutlined.js
// module id = 4362
// module chunks = 0